import React, { useEffect } from "react";
import "./Loader.css";
export const Loader = () => {
  useEffect(() => {
  
  }, []);
  return (
    <>
      <div className=" loader-body">
        <div className="col-12 custom-loader"></div>
      </div>
    </>
  );
};
export {};
